import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import SectionHeader from '../../shared/section-header';

import style from './index.module.scss';

function ProfileFeeds({
  user: {
    id,
    fullname,
    followers,
    following,
    addedQuestions,
    addedAnswers,
    addedBlogPosts,
  },
}) {
  const feeds = [
    { name: 'Questions', path: 'questions', total: addedQuestions.length },
    { name: 'Shares', path: 'shares', total: 18 },
    { name: 'Blogs', path: 'blogs', total: addedBlogPosts.length },
    { name: 'Followers', path: 'followers', total: followers.length },
    { name: 'Following', path: 'following', total: following.length },
    { name: 'Topics', path: 'topics', total: 43 },
  ];

  return (
    <aside className={`col ${style['col--feeds']}`}>
      <SectionHeader headingLeft="Feeds" headingRight="" colWith={12} />
      <nav className={`row ${style['row--feed-links']}`}>
        <div className={`col-12 ${style['col--feed-links']}`}>
          <NavLink
            className={style['feed-link']}
            activeClassName={style['feed-link--active']}
            to={{
              pathname: `/account/${fullname}`,
              state: {
                userId: id,
              },
            }}
            exact
          >
            Answers <span className="text-muted">{addedAnswers.length}</span>
          </NavLink>
          {feeds.map((feed, index) => (
            <NavLink
              className={style['feed-link']}
              activeClassName={style['feed-link--active']}
              to={{
                pathname: `/account/${fullname}/${feed.path}`,
                state: {
                  userId: id,
                },
              }}
              key={index}
            >
              {feed.name} <span className="text-muted">{feed.total}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </aside>
  );
}

ProfileFeeds.propTypes = {
  user: PropTypes.shape({
    followers: PropTypes.array.isRequired,
    following: PropTypes.array.isRequired,
    addedAnswers: PropTypes.array.isRequired,
    addedQuestions: PropTypes.array.isRequired,
    addedBlogPosts: PropTypes.array.isRequired,
  }).isRequired,
};

export default ProfileFeeds;
